export const sanitizeStrings = (strings: string[]) => {
  return Array.isArray(strings) ? strings.map(String) : [];
};
